<!-- <hr class="line" [ngStyle]="{ background: newColor }" />
<app-topnav [pagename]="'Workflow Management'"></app-topnav> -->

<!-- Brand Selection Popup Overlay - COMMENTED OUT: Auto-loading first brand instead -->
<!-- 
<div *ngIf="showBrandPopup" class="brand-popup-overlay">
  <div class="brand-popup-modal">
    <div class="brand-popup-header">
      <h3>Select Brand</h3>
    </div>

    <div class="brand-popup-content">
      <div *ngIf="isLoadingBrands" class="progress-indicator text-center h-100">
        <loading></loading>
      </div>

      <div *ngIf="!isLoadingBrands && brands.length > 0">
        <mat-form-field style="width: 100%" appearance="fill" class="matFformFieldConfig">
          <mat-label>Choose Brand</mat-label>
          <mat-select [(ngModel)]="selectedBrand">
            <mat-option style="font-family: 'Poppins';" *ngFor="let brand of brands" [value]="brand.brand_key"
              [title]="brand.brand_name">
              {{ brand.brand_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="!isLoadingBrands && brands.length === 0" class="no-brands-message">
        <div class="text-center">
          <mat-icon class="no-brands-icon">warning</mat-icon>
          <h4 class="mt-3">No Brands Available</h4>
          <p class="text-muted">
            You don't have access to any brands.<br>
            Please contact your administrator for access.
          </p>
        </div>
      </div>

      <div class="text-center mt-3 gap-2 d-flex justify-content-center">
        <button type="button" class="scraii-secondary-btn" (click)="goBack()">
          {{brands.length === 0 ? 'Go Back' : 'Cancel'}}
        </button>

        <button type="button" class="scraii-primary-btn" *ngIf="brands.length > 0"
          [disabled]="!selectedBrand || isLoadingBrands" (click)="confirmBrandSelection()">
          Confirm
        </button>
      </div>
    </div>
  </div>
</div>
-->

<!-- Main Content - Auto-loads with first brand selected -->
<div style="max-height: calc(100dvh - 100px); overflow-y: auto">

  <!-- Template Listing View -->
  <div *ngIf="showTemplateList && !showDesigner" class="scraii-template-card">
    <div class="etd-card-header">
      <h4 class="etd-card-title">Email Templates</h4>
      <div class="etd-card-actions">
        <div class="etd-brand-dropdown-wrapper">
          <button class="etd-brand-dropdown-btn" [class.open]="brandDropdownOpen"
              (click)="toggleBrandDropdown($event)">
            <span class="etd-brand-btn-label">{{ selectedBrand?.brand_name || 'Select Brand' }}</span>
            <mat-icon class="etd-brand-btn-arrow">{{ brandDropdownOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <div class="etd-brand-dropdown-panel" *ngIf="brandDropdownOpen" (click)="$event.stopPropagation()">
            <div class="etd-brand-search-wrap">
              <input class="etd-brand-search-input" type="text" placeholder="Search..."
                  autocomplete="off" [ngModel]="brandSearchText"
                  (ngModelChange)="onBrandSearch($event)" />
            </div>
            <div *ngIf="isLoadingBrands" class="etd-brand-loading">
              <mat-spinner diameter="16"></mat-spinner>
              <span>Loading...</span>
            </div>
            <div class="etd-brand-list" *ngIf="!isLoadingBrands">
              <div *ngIf="filteredBrands.length === 0" class="etd-brand-empty">No brands found</div>
              <div *ngFor="let brand of filteredBrands" class="etd-brand-item"
                  [class.selected]="selectedBrand?.brand_key === brand.brand_key"
                  (click)="selectBrand(brand)">
                <div class="etd-brand-checkbox"
                    [class.checked]="selectedBrand?.brand_key === brand.brand_key">
                  <mat-icon *ngIf="selectedBrand?.brand_key === brand.brand_key"
                      class="etd-brand-check-icon">check</mat-icon>
                </div>
                <span class="etd-brand-item-name">{{ brand.brand_name }}</span>
              </div>
            </div>
          </div>
        </div>
        <button class="scraii-primary-btn" (click)="createNewTemplate()">
          <span class="material-icons" style="font-size: 18px; vertical-align: middle; margin-right: 4px;">add</span>
          Create Email Design
        </button>
      </div>
    </div>
    <!-- Grid container — mirrors workflow-management's workflow-grid-container:
         position:relative scopes the loader overlay; min-height keeps the
         card tall even when the template list is empty or loading. -->
    <div class="etd-grid-container">

      <!-- Overlay loader — covers only the table area, not the header -->
      <div *ngIf="isLoadingTemplates" class="etd-grid-loader">
        <loading></loading>
      </div>

      <!-- AG Grid -->
      <div *ngIf="templates.length > 0">
        <ag-grid-angular
          style="width: 100%; font-family: 'Poppins';"
          class="ag-theme-balham patientGrid"
          [rowData]="templates"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          [gridOptions]="gridOptions"
          [pagination]="true"
          [paginationPageSize]="paginationPageSize"
          [suppressPaginationPanel]="true"
          [rowHeight]="52"
          [headerHeight]="48"
          [domLayout]="'autoHeight'"
          (gridReady)="onGridReady($event)"
          (paginationChanged)="onPaginationChanged()">
        </ag-grid-angular>
      </div>

      <!-- Empty state — only shown when load is done and no results -->
      <div *ngIf="!isLoadingTemplates && templates.length === 0" class="etd-empty-state">
        <mat-icon>email</mat-icon>
        <h5>No templates found</h5>
        <p>Create your first email template to get started</p>
      </div>

    </div>

    <!-- Pagination footer — sibling of etd-grid-container, same structure as
         workflow-management's workflow-pagination-footer outside the grid -->
    <div class="etd-pagination-footer">
      <div class="etd-pagination-left">
        <span class="etd-pagination-label">Rows per page</span>
        <mat-form-field appearance="outline" class="etd-page-size-field">
          <mat-select [(ngModel)]="paginationPageSize" (ngModelChange)="onPageSizeChange($event)">
            <mat-option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="etd-pagination-right">
        <button class="etd-page-btn" [disabled]="currentPage === 0" (click)="goToPage(currentPage - 1)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg>
        </button>
        <ng-container *ngFor="let page of visiblePages">
          <span *ngIf="page === '...'" class="etd-page-ellipsis">...</span>
          <button *ngIf="page !== '...'" class="etd-page-num"
            [class.etd-page-active]="page === currentPage + 1"
            (click)="goToPage(+page - 1)">{{ page }}</button>
        </ng-container>
        <button class="etd-page-btn" [disabled]="currentPage >= totalPages - 1" (click)="goToPage(currentPage + 1)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>
        </button>
      </div>
    </div>

  </div>

  <!-- Email Designer View -->
  <div *ngIf="showDesigner" class="scraii-email-temp">
    <!-- top bar -->
    <header class="scraii-topbar" role="banner">
      <div class="scraii-topbar__title">
        {{ isEditMode ? 'Edit Email Template' : 'Email Template Creation' }}
      </div>
      <div class="d-flex gap-1">
        <button class="scraii-secondary-btn" (click)="backToTemplateList()">
          <span class="material-icons"
            style="font-size: 18px; vertical-align: middle; margin-right: 4px;">arrow_back</span>
          Back to List
        </button>
        <button class="scraii-primary-btn" (click)="saveTemplate()" [disabled]="sections.length === 0">
          {{ isEditMode ? 'Update' : 'Save' }}
        </button>
        <button class="scraii-secondary-btn" (click)="clearTemplate()">Clear</button>
      </div>
    </header>

    <div class="scraii-body">
      <!-- SIDEBAR -->
      <aside class="scraii-sidebar col-md-3 col-12">
        <nav class="scraii-nav">
          <button class="scraii-nav__item" [class.scraii-nav__item--active]="activeTab === 'builder'"
            (click)="setActiveTab('builder')">
            <span class="scraii-nav__icon material-icons">edit_note</span>
            <span class="scraii-nav__label">Content Builder</span>
          </button>

          <!-- <button class="scraii-nav__item" [class.scraii-nav__item--active]="activeTab === 'settings'"
            (click)="setActiveTab('settings')">
            <span class="scraii-nav__icon">⚙️</span>
            <span class="scraii-nav__label">Settings</span>
          </button> -->

          <button class="scraii-nav__item" [class.scraii-nav__item--active]="activeTab === 'preview'"
            [disabled]="!templateName || sections.length === 0 || !isTemplateSaved"
            [title]="!templateName ? 'Template name is required' : sections.length === 0 ? 'Please add content to preview' : !isTemplateSaved ? 'Please save as draft before previewing' : 'Click to preview'"
            (click)="setActiveTab('preview')">
            <span class="scraii-nav__icon material-icons">visibility</span>
            <span class="scraii-nav__label">Preview</span>
          </button>
        </nav>
      </aside>

      <div style="height: -webkit-fill-available; border-left: 1px solid #ddd"></div>

      <!-- MAIN AREA -->
      <main class="scraii-main col-md-9 col-12">
        <!-- BUILDER TAB -->
        <div *ngIf="activeTab === 'builder'">
          <section class="p-3 pb-0">
            <label class="form-label">Template name
              <!-- if template name is empty show red else no astrid -->
              <span class="text-danger" *ngIf="templateName === ''">*</span></label>
            <input class="form-control" [(ngModel)]="templateName" placeholder="Enter template name" />
          </section>
          <section class="p-3 pb-0">
            <label class="form-label">Email Subject
              <span class="text-danger" *ngIf="emailSubject === ''">*</span></label>
            <input class="form-control" [(ngModel)]="emailSubject" placeholder="Enter email subject" />
          </section>
          <section class="d-flex justify-content-start align-items-center p-3 pb-0 gap-2">
            <button class="scraii-secondary-btn" (click)="addHeader()">
              <span class="material-icons" style="font-size: 16px; vertical-align: middle; margin-right: 4px;">add</span>Add Header
            </button>
            <button class="scraii-secondary-btn" (click)="addTable()">
              <span class="material-icons" style="font-size: 16px; vertical-align: middle; margin-right: 4px;">add</span>Add Table
            </button>
            <button class="scraii-secondary-btn" (click)="addAttachment()" [disabled]="hasAttachmentSection">
              <span class="material-icons" style="font-size: 16px; vertical-align: middle; margin-right: 4px;">add</span>Add Attachment
            </button>
            <button class="scraii-secondary-btn" (click)="addFooter()">
              <span class="material-icons" style="font-size: 16px; vertical-align: middle; margin-right: 4px;">add</span>Add Footer
            </button>
          </section>

          <!-- Empty state -->
          <section class="scraii-card mt-3 d-flex justify-content-center align-items-center" style="min-height: 300px"
            *ngIf="sections.length === 0">
            <div class="mt-1 text-muted small fs-6">
              No components added yet. Use the buttons above to add content.
            </div>
          </section>

          <!-- Sections list (DRAGGABLE) -->
          <div *ngIf="sections.length > 0" cdkDropList [cdkDropListData]="sections"
            (cdkDropListDropped)="onSectionDrop($event)">
            <section class="scraii-card mt-3" *ngFor="let sec of sections; let i = index" cdkDrag>
              <!-- Section header -->
              <div class="d-flex justify-content-between align-items-center mb-2">
                <div class="d-flex align-items-center gap-2">
                  <!-- drag handle -->
                  <span class="scraii-drag-handle" cdkDragHandle>⋮⋮</span>

                  <div style="font-weight: 700; text-transform: capitalize">
                    {{ sec.type }}
                    <span *ngIf="sec.type === 'table' && sec['dynamicConfig']" class="badge bg-success ms-1">
                      Configured
                    </span>
                    <span *ngIf="sec.type === 'table' && !sec['dynamicConfig']" class="badge bg-secondary ms-1">
                      Not configured
                    </span>
                  </div>
                </div>

                <div class="d-flex gap-1 align-items-center">
                  <!-- Header style settings icon -->
                  <button *ngIf="sec.type === 'header'" class="etd-icon-btn header-settings-btn"
                    type="button" (click)="toggleHeaderToolbar(sec)" [class.active]="sec['_showHeaderToolbar']"
                    title="Header style settings">
                    <span class="material-icons">settings</span>
                  </button>

                  <!-- Footer style settings icon -->
                  <button *ngIf="sec.type === 'footer'" class="etd-icon-btn footer-settings-btn"
                    type="button" (click)="toggleFooterToolbar(sec)" [class.active]="sec['_showFooterToolbar']"
                    title="Footer style settings">
                    <span class="material-icons">settings</span>
                  </button>
                  <!-- Table settings icon -->
                  <button *ngIf="sec.type === 'table'" class="etd-icon-btn" type="button"
                    (click)="openTableSettings(sec)" title="Configure data table">
                    <span class="material-icons">settings</span>
                  </button>

                  <button class="etd-icon-btn etd-icon-btn--danger" type="button" (click)="removeSection(i)" title="Remove section">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#e53e3e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="3 6 5 6 21 6"></polyline>
                      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                      <path d="M10 11v6"></path><path d="M14 11v6"></path>
                      <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>
                    </svg>
                  </button>
                </div>
              </div>

              <!-- HEADER SECTION -->
              <div *ngIf="sec.type === 'header'" class="position-relative">
                <!-- Toolbar popup (shown when settings icon clicked) -->
                <div class="header-toolbar-popup" *ngIf="sec['_showHeaderToolbar']">
                  <div class="email-template-toolbar">
                    <!-- Heading selector -->
                    <div class="email-template-tool-group" matTooltipPosition="above" matTooltip="Font size">
                      <select class="email-template-heading-selector" [ngModel]="getHeaderHeading(sec)"
                        (ngModelChange)="onHeaderHeadingChange(sec, $event)">
                        <option value="p">Normal</option>
                        <option value="h1">Heading 1</option>
                        <option value="h2">Heading 2</option>
                        <option value="h3">Heading 3</option>
                      </select>
                    </div>

                    <div class="email-template-divider"></div>

                    <!-- Bold / Italic / Underline / Strike -->
                    <div class="email-template-tool-group">
                      <button type="button" class="border" matTooltipPosition="above" matTooltip="Bold"
                        [class.active]="isHeaderBold(sec)" (click)="toggleHeaderBold(sec)" title="Bold">
                        <span class="material-icons">format_bold</span>
                      </button>
                      <button type="button" class="border" matTooltipPosition="above" matTooltip="Italic"
                        [class.active]="isHeaderItalic(sec)" (click)="toggleHeaderItalic(sec)" title="Italic">
                        <span class="material-icons">format_italic</span>
                      </button>
                      <button type="button" class="border" matTooltipPosition="above" matTooltip="Underline"
                        [class.active]="isHeaderUnderline(sec)" (click)="toggleHeaderUnderline(sec)" title="Underline">
                        <span class="material-icons">format_underlined</span>
                      </button>
                      <button type="button" class="border" matTooltipPosition="above" matTooltip="Strikethrough"
                        [class.active]="isHeaderStrike(sec)" (click)="toggleHeaderStrike(sec)" title="Strikethrough">
                        <span class="material-icons">strikethrough_s</span>
                      </button>
                    </div>

                    <div class="email-template-divider"></div>

                    <!-- Alignment -->
                    <div class="email-template-tool-group">
                      <button type="button" class="border" matTooltipPosition="above" matTooltip="Align Left"
                        [class.active]="isHeaderAlign(sec, 'left')" (click)="setHeaderAlign(sec, 'left')"
                        title="Align Left">
                        <span class="material-icons">format_align_left</span>
                      </button>
                      <button type="button" class="border" matTooltipPosition="above" matTooltip="Align Center"
                        [class.active]="isHeaderAlign(sec, 'center')" (click)="setHeaderAlign(sec, 'center')"
                        title="Align Center">
                        <span class="material-icons">format_align_center</span>
                      </button>
                      <button type="button" class="border" matTooltipPosition="above" matTooltip="Align Right"
                        [class.active]="isHeaderAlign(sec, 'right')" (click)="setHeaderAlign(sec, 'right')"
                        title="Align Right">
                        <span class="material-icons">format_align_right</span>
                      </button>
                    </div>

                    <div class="email-template-divider"></div>

                    <!-- Color pickers -->
                    <div class="email-template-tool-group email-template-color-group">
                      <!-- Text color -->
                      <div class="email-template-color-wrapper border" title="Text Color" matTooltipPosition="above"
                        matTooltip="Font color">
                        <span class="material-icons email-template-color-icon" [style.color]="getHeaderTextColor(sec)">
                          format_color_text
                        </span>
                        <input type="color" [value]="getHeaderTextColor(sec)"
                          (change)="onHeaderTextColorChange(sec, $event)" />
                      </div>

                      <!-- Background color -->
                      <div class="email-template-color-wrapper border" title="Background Color"
                        matTooltipPosition="above" matTooltip="Background color">
                        <span class="material-icons email-template-color-icon" [style.color]="getHeaderBgColor(sec)">
                          border_color
                        </span>
                        <input type="color" [value]="getHeaderBgColor(sec)"
                          (change)="onHeaderBgColorChange(sec, $event)" />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Header text input (styled directly) -->
                <label class="form-label mt-2">Header text</label>
                <input class="form-control" [(ngModel)]="sec['title']" [ngStyle]="getHeaderInputStyle(sec)" />
              </div>

              <!-- TABLE SECTION: summary only -->
              <div *ngIf="sec.type === 'table'">
                <div *ngIf="sec['dynamicConfig']; else noTableConfig">
                  <div class="mb-2">
                    <div>
                      <strong>Display title:</strong>
                      {{ sec["dynamicConfig"].displayTitle || "-" }}
                    </div>
                    <div>
                      <strong>Placeholder:</strong>
                      {{ sec["dynamicConfig"].placeholderName || "-" }}
                    </div>
                    <div class="mt-1">
                      <strong>SQL:</strong>
                      <code class="small d-block text-truncate" style="max-width: 100%">
                        {{ sec["dynamicConfig"].sqlQuery }}
                      </code>
                    </div>
                    <div class="mt-1 text-muted small">
                      Styling and full preview are managed in the "Data Table"
                      dialog.
                    </div>
                  </div>
                </div>

                <ng-template #noTableConfig>
                  <div class="text-muted">
                    Data table not configured yet. Click the settings icon to
                    configure this table.
                  </div>
                </ng-template>
              </div>

              <!-- ATTACHMENTS (File Upload OR SQL Configuration) -->
              <div *ngIf="sec.type === 'attachments'">

                <!-- Radio Button Mode Selection -->
                <div class="mb-3">
                  <label class="form-label fw-bold">Attachment Mode</label>
                  <div class="d-flex gap-3">
                    <div class="form-check">
                      <input class="form-check-input" type="radio" name="attachmentMode_{{sec.id}}"
                        id="fileMode_{{sec.id}}" value="file" [checked]="sec['mode'] === 'file'"
                        (change)="onAttachmentModeChange(sec, 'file')">
                      <label class="form-check-label" for="fileMode_{{sec.id}}">
                        File Upload
                      </label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="radio" name="attachmentMode_{{sec.id}}"
                        id="sqlMode_{{sec.id}}" value="sql" [checked]="sec['mode'] === 'sql'"
                        (change)="onAttachmentModeChange(sec, 'sql')">
                      <label class="form-check-label" for="sqlMode_{{sec.id}}">
                        SQL Query
                      </label>
                    </div>
                  </div>
                </div>

                <!-- File Upload Section (shown when mode is 'file') -->
                <div *ngIf="sec['mode'] === 'file'">
                  <div class="mb-3">
                    <label class="form-label">Upload Files</label>
                    <input type="file" class="form-control" multiple (change)="onAttachmentFilesSelected(sec, $event)"
                      #fileInput />
                    <small class="text-muted">You can select multiple files</small>
                  </div>

                  <!-- Display selected files -->
                  <div *ngIf="sec['files'] && sec['files'].length > 0" class="mb-3">
                    <label class="form-label">Selected Files:</label>
                    <div class="list-group">
                      <div *ngFor="let file of sec['files']"
                        class="list-group-item d-flex justify-content-between align-items-center">
                        <div>
                          <span class="material-icons"
                            style="vertical-align: middle; font-size: 18px; margin-right: 8px;">attach_file</span>
                          <span>{{ file.name }}</span>
                          <small class="text-muted ms-2">({{ formatFileSize(file.size) }})</small>
                        </div>
                        <button type="button" class="etd-icon-btn etd-icon-btn--danger"
                          (click)="removeAttachmentFile(sec, file.id)" title="Remove file">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#e53e3e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="3 6 5 6 21 6"></polyline>
                            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                            <path d="M10 11v6"></path><path d="M14 11v6"></path>
                            <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- SQL Query Section (shown when mode is 'sql') -->
                <div *ngIf="sec['mode'] === 'sql'">
                  <div class="mb-3">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <label class="form-label fw-bold mb-0">SQL Query Configurations</label>
                      <button type="button" class="scraii-secondary-btn" (click)="addSqlQuery(sec)">
                        <span class="material-icons" style="font-size: 16px; vertical-align: middle; margin-right: 4px;">add</span>Add Query
                      </button>
                    </div>

                    <!-- List of SQL Queries -->
                    <div *ngFor="let query of sec['sqlQueries']; let i = index" class="border rounded p-3 mb-3">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <h6 class="mb-0">Query #{{ i + 1 }}</h6>
                        <button type="button" class="etd-icon-btn etd-icon-btn--danger"
                          (click)="removeSqlQuery(sec, query.id)"
                          [disabled]="sec['sqlQueries'].length === 1" title="Remove query">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#e53e3e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="3 6 5 6 21 6"></polyline>
                            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                            <path d="M10 11v6"></path><path d="M14 11v6"></path>
                            <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>
                          </svg>
                        </button>
                      </div>

                      <div class="mb-2">
                        <label class="form-label">SQL Query</label>
                        <textarea rows="3" class="form-control" placeholder="Enter SQL query"
                          [(ngModel)]="query.sqlQuery"></textarea>
                      </div>

                      <div class="mb-2">
                        <label class="form-label">Secret Key</label>
                        <input type="text" class="form-control" placeholder="Enter secret key"
                          [(ngModel)]="query.secretKey" />
                      </div>

                      <div class="mb-2">
                        <label class="form-label">Connection String</label>
                        <textarea rows="2" class="form-control" placeholder="Enter connection string"
                          [(ngModel)]="query.connectionString"></textarea>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <!-- FOOTER -->
              <div *ngIf="sec.type === 'footer'" class="position-relative">
                <!-- Toolbar popup (shown when footer settings icon clicked) -->
                <div class="footer-toolbar-popup" *ngIf="sec['_showFooterToolbar']">
                  <div class="email-template-toolbar">
                    <!-- Heading selector -->
                    <div class="email-template-tool-group" matTooltipPosition="above" matTooltip="Font size">
                      <select class="email-template-heading-selector" [ngModel]="getFooterHeading(sec)"
                        (ngModelChange)="onFooterHeadingChange(sec, $event)">
                        <option value="p">Normal</option>
                        <option value="h1">Heading 1</option>
                        <option value="h2">Heading 2</option>
                        <option value="h3">Heading 3</option>
                      </select>
                    </div>

                    <div class="email-template-divider"></div>

                    <!-- Bold / Italic / Underline / Strike -->
                    <div class="email-template-tool-group">
                      <button type="button" class="border" matTooltipPosition="above" matTooltip="Bold"
                        [class.active]="isFooterBold(sec)" (click)="toggleFooterBold(sec)" title="Bold">
                        <span class="material-icons">format_bold</span>
                      </button>
                      <button type="button" class="border" matTooltipPosition="above" matTooltip="Italic"
                        [class.active]="isFooterItalic(sec)" (click)="toggleFooterItalic(sec)" title="Italic">
                        <span class="material-icons">format_italic</span>
                      </button>
                      <button type="button" class="border" matTooltipPosition="above" matTooltip="Underline"
                        [class.active]="isFooterUnderline(sec)" (click)="toggleFooterUnderline(sec)" title="Underline">
                        <span class="material-icons">format_underlined</span>
                      </button>
                      <button type="button" class="border" matTooltipPosition="above" matTooltip="Strikethrough"
                        [class.active]="isFooterStrike(sec)" (click)="toggleFooterStrike(sec)" title="Strikethrough">
                        <span class="material-icons">strikethrough_s</span>
                      </button>
                    </div>

                    <div class="email-template-divider"></div>

                    <!-- Alignment -->
                    <div class="email-template-tool-group">
                      <button type="button" class="border" matTooltipPosition="above" matTooltip="Align Left"
                        [class.active]="isFooterAlign(sec, 'left')" (click)="setFooterAlign(sec, 'left')"
                        title="Align Left">
                        <span class="material-icons">format_align_left</span>
                      </button>
                      <button type="button" class="border" matTooltipPosition="above" matTooltip="Align Center"
                        [class.active]="isFooterAlign(sec, 'center')" (click)="setFooterAlign(sec, 'center')"
                        title="Align Center">
                        <span class="material-icons">format_align_center</span>
                      </button>
                      <button type="button" class="border" matTooltipPosition="above" matTooltip="Align Right"
                        [class.active]="isFooterAlign(sec, 'right')" (click)="setFooterAlign(sec, 'right')"
                        title="Align Right">
                        <span class="material-icons">format_align_right</span>
                      </button>
                    </div>

                    <div class="email-template-divider"></div>

                    <!-- Color pickers -->
                    <div class="email-template-tool-group email-template-color-group">
                      <!-- Text color -->
                      <div class="email-template-color-wrapper border" title="Text Color" matTooltipPosition="above"
                        matTooltip="Font color">
                        <span class="material-icons email-template-color-icon" [style.color]="getFooterTextColor(sec)">
                          format_color_text
                        </span>
                        <input type="color" [value]="getFooterTextColor(sec)"
                          (change)="onFooterTextColorChange(sec, $event)" />
                      </div>

                      <!-- Background color -->
                      <div class="email-template-color-wrapper border" title="Background Color"
                        matTooltipPosition="above" matTooltip="Background color">
                        <span class="material-icons email-template-color-icon" [style.color]="getFooterBgColor(sec)">
                          border_color
                        </span>
                        <input type="color" [value]="getFooterBgColor(sec)"
                          (change)="onFooterBgColorChange(sec, $event)" />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Footer text input (styled directly) -->
                <label class="form-label">Footer Text</label>
                <textarea class="form-control" rows="3" [(ngModel)]="sec['content']"
                  [ngStyle]="getFooterInputStyle(sec)"></textarea>
              </div>
            </section>
          </div>
        </div>

        <!-- SETTINGS TAB -->
        <!-- <div *ngIf="activeTab === 'settings'">
          <section class="scraii-card">
            <h4>Template settings</h4>

            <div class="mb-2">
              <label class="form-label">Template name</label>
              <input class="form-control" [(ngModel)]="templateName" />
            </div>

            <div class="d-flex gap-2 mt-2">
              <button class="scraii-primary-btn" (click)="setActiveTab('builder')">
                Back to Builder
              </button>
              <button class="scraii-save-btn" (click)="setActiveTab('preview')">
                Save & Preview
              </button>
            </div>
          </section>
        </div> -->

        <!-- PREVIEW TAB -->
        <div *ngIf="activeTab === 'preview'">
          <section class="scraii-card">
            <h4>Live preview</h4>

            <!-- Loading indicator -->
            <div *ngIf="isLoadingPreview" class="d-flex justify-content-center align-items-center" style="
                height: 60vh;
                border: 1px solid #eee;
                border-radius: 8px;
                background: #fff;
              ">
              <app-progress-indefinite class="progress-indicator"></app-progress-indefinite>
            </div>

            <!-- Preview content -->
            <div *ngIf="!isLoadingPreview" class="scraii-preview-html" style="
                height: 60vh;
                border: 1px solid #eee;
                overflow: auto;
                padding: 16px;
                border-radius: 8px;
                background: #fff;
              " [innerHTML]="previewHtml"></div>

            <div class="d-flex gap-2 mt-2">
              <button class="scraii-secondary-btn" (click)="setActiveTab('builder')">
                Back to Builder
              </button>
              <button class="scraii-secondary-btn" (click)="downloadJson()">
                Download JSON
              </button>
            </div>
          </section>
        </div>
      </main>
    </div>
  </div>
</div>

